import React from 'react'
import styled from '@emotion/styled'
import { bool, shape, string } from 'prop-types'

import { SponsoredLink } from '../SponsoredLink'
import { makeImgResizerUrl } from '@jelly/utils'

const AuthorContext = styled.div`
	color: ${({ theme }) => theme.colors.darkGrey};
	display: flex;
	flex-direction: row;
	font-size: 16px;
	width: 100%;
`
const SponsoredLogo = styled.img`
	margin: auto;
	margin-left: 9px;
	height: 32px;
`
const AuthorThumbnail = styled.img`
	border-radius: 50%;
	height: 32px;
	width: 32px;
`
const Author = styled.div`
	font-size: 16px;
	margin: auto;
	margin-left: 9px;
`

AuthorInfo.propTypes = {
	author: shape({
		name: string,
		displayName: string,
		thumbnail: string,
	}),
	sponsor: shape({
		name: string.isRequired,
		logo: string.isRequired,
	}),
	isSponsored: bool,
}

/**
 * This is an article card for the HUBSEvergreen Article Section
 * Image for author, priority is user.image, than ccm.image
 * if both don't exist then we check to see if gravatar returns an image
 *
 * @param {Object} props.author Data for the author who wrote the current article
 * @param {Object} props.sponsor Sponsored data, company name, logo, etc
 * @param {Boolean} props.isSponsored Boolean value based on if the hub page is sponsored
 */

export function AuthorInfo({ author, sponsor, isSponsored }) {
	if (author) {
		const src = author.thumbnail || author.user?.imagePath
		const authorSrc = makeImgResizerUrl({ src, method: 'w', w: 32 })
		return (
			<AuthorContext>
				{sponsor && isSponsored ? (
					<>
						Sponsored Content From:
						<SponsoredLink
							sponsorLink={sponsor.social && sponsor.social.website}
							sponsorName={sponsor.name}
						>
							<SponsoredLogo
								alt={sponsor.name}
								src={makeImgResizerUrl({
									src: sponsor.logo || sponsor.avatar,
									method: 'h',
									h: '32-png',
								})}
							/>
						</SponsoredLink>
					</>
				) : (
					<>
						<AuthorThumbnail alt={author.name || author.displayName} src={authorSrc} />
						<Author>{author.name || author.displayName}</Author>
					</>
				)}
			</AuthorContext>
		)
	}
	return null
}
